import { LIST_REQUEST_ASYNC, PAGINATE_CHANGE, REPORT_SELECT, URL_STATE_CHANGE } from './constants'

export const fetchIncidentsList = ({ isPolling } = {}) => ({
  type: LIST_REQUEST_ASYNC.INITIATE,
  payload: { isPolling },
})
export const fetchIncidentsListSuccess = (data) => ({
  type: LIST_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchIncidentsListError = (error) => ({
  type: LIST_REQUEST_ASYNC.ERROR,
  error,
})

export const selectReport = (id, type) => ({
  type: REPORT_SELECT,
  payload: { id, type },
})

export const changeUrlState = (category) => ({
  type: URL_STATE_CHANGE,
  payload: {
    urlState: category,
  },
})

const paginateChange = (page) => ({ type: PAGINATE_CHANGE, payload: { page } })

export default {
  // to props
  fetchIncidentsList,
  selectReport,
  paginateChange,
}
